import { render } from "./CommunityDateTimeDisplay.vue?vue&type=template&id=0c42c92a"
import script from "./CommunityDateTimeDisplay.vue?vue&type=script&lang=js"
export * from "./CommunityDateTimeDisplay.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__